import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseRefreshSessionRepository } from '@/modules/auth/infra'
import type { RefreshSession } from '@/modules/auth/use-cases'

export function makeRefreshSession(): RefreshSession {
  return new SupabaseRefreshSessionRepository(makeSupabaseClient()).execute
}
